<template>
  <div style="height:calc(100% - 52px);">
    <div style="height:calc(100% - 52px);">
      <div v-show="!showInterfaceList" style="height:100%">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <w-obj-type-filter ref="objTypeFilter" :init-load="true" :include-selection="false" :managetype-data="physicalObjFilterManagetypeData" @filter-change="onPhysicalObjFilterChange" />
          <w-header-search-button size="mini" @click="objShowSearchTool = !objShowSearchTool"></w-header-search-button>
        </el-row>
        <el-table-wrapper ref="physicalObjTable" style="height:calc(100% - 41px);" row-class-name="c-pointer" :fit-height="true" :data="objTableData" :total="objTotal" :columns="objColumns" :show-search-tool="objShowSearchTool" remote pagination :show-custom-header="true"
          :highlight-current-row="true" @condition-change="loadPhysicalObjTableData" @row-click="setSelectedObjToTable">
          <template slot-scope="scope" slot="interface-slot">
            <span :class="$style.pointer"><i class="el-icon-search" style="cursor: pointer" @click="onClickInterfaceButton(scope.row)" /></span>
          </template>
        </el-table-wrapper>
      </div>
      <w-interface-table v-show="showInterfaceList" ref="interfaceTable" :active="showInterfaceList" :device-data="selectedDeviceData" :filter-params="objTypeFilterParams"
      :fit-height="true" @on-click-back-button="showInterfaceList = !showInterfaceList" @row-click="setSelectedObjToTable" />
    </div>
  </div>
</template>

<script>
import { isEmpty, findIndex, cloneDeep } from 'lodash';
import { isObjNode, isRequireIPObjType, getObjNodeLabel } from '@/utils/tree';
import { defaultProps } from '@/constants/tree';
import TreeFilter from '@/mixins/tree/filter';
import msgUtil from '@/utils/message';
import LogicalGroupApi from '@/api/settings/common/logical-group';
import WObjTypeFilter from '@/components/table/PhysicalObjTable/ObjTypeFilter';
import WSearchField from '@/components/form/SearchField';
import WInterfaceTable from './InterfaceTable';

export default {
  name: 'WSettingTargetObjTree',
  mixins: [TreeFilter],
  components: {
    WObjTypeFilter,
    WSearchField,
    WInterfaceTable,
  },
  props: {
    objViewType: String,
  },
  data() {
    return {
      isFirstLoadTable: false,
      objTypeFilterParams: null,
      objTableData: [],
      objTotal: 0,
      objColumns: [],
      objTreeData: [],
      objShowSearchTool: false,
      selectedObj: null,
      treeRef: 'logicalTree',
      treeDefaultProps: defaultProps,
      showInterfaceList: false,
      selectedDeviceData: null,
    };
  },
  computed: {
    /**
     * 물리 그룹 장비 필터 관리 구분 정보
     * @author Ju
     * @return {Array}
     */
    physicalObjFilterManagetypeData() {
      return this.$store.getters.activeManagetypesToShowForRsc;
    },
  },
  watch: {
    objViewType: {
      handler() {
        if (this.objTypeFilterParams === null) {
          this.$nextTick(() => {
            this.$refs.objTypeFilter.loadManagetype();
          });
        } else {
          this.loadPhysicalObjTableData();
        }
      },
      immediate: true,
    },
    objTypeFilterParams: {
      handler(to, from) {
        if (!isEmpty(to)) {
          if (isEmpty(from) || to.params.managetypeId !== from.params.managetypeId || to.params.managetypeKey !== from.params.managetypeKey) {
            // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
            // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
            this.objColumns = [];
            this.$refs.physicalObjTable.clearFilter();
            this.$nextTick(() => {
              const managetypeId = to.params.managetypeId;
              if (managetypeId === 'NMS') {
                const netdeviceColumns = cloneDeep(to.columns);
                netdeviceColumns.push({
                  label: '인터페이스',
                  width: 80,
                  align: 'center',
                  scopedSlot: 'interface-slot',
                });
                this.objColumns = netdeviceColumns;
              } else {
                this.objColumns = to.columns;
              }
            });
          }
          // this.selectedObj = null;
          this.loadPhysicalObjTableData();
        }
      },
    },
  },
  methods: {
    isObjNode,
    isRequireIPObjType,
    getObjNodeLabel,
    initData() {
      this.selectedObj = null;
    },
    /**
     * 물리 그룹 관리 대상 테이블 정보를 로드한다.
     * @author Ju
     */
    loadPhysicalObjTableData() {
      // if (!isEmpty(this.objTypeFilterParams) && !isEmpty(this.objTypeFilterParams.columns)) {
      //   this.$nextTick(() => {
      //     this.objColumns = this.objTypeFilterParams.columns;
      //   });
      // }
      const tableParams = {
        ...this.objTypeFilterParams.params,
        ...this.$refs.physicalObjTable.getParameter(),
      };
      LogicalGroupApi.getPhysicalObjList(tableParams)
        .then((response) => {
          if (response.data.success) {
            this.objTableData = response.data.data;
            this.objTotal = response.data.total;
            if (!isEmpty(this.objTableData)) {
              // if (isEmpty(this.selectedObj)) {
              this.selectedObj = this.objTableData[0];
              // } else {
              // const index = findIndex(this.objTableData, (item) => item.objId === this.selectedObj.objId);
              // if (index >= 0) {
              // this.selectedObj = this.objTableData[index];
              this.$refs.physicalObjTable.getTable().setCurrentRow(this.selectedObj);
              this.setSelectedObjToTable(this.selectedObj);
              // }
              // }
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 대상 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 대상 정보', false));
          throw new Error(e);
        });
    },
    setSelectedObjToTree(node) {
      if (node.type === 'obj') {
        this.selectedObj = {
          objId: node.obj.objId,
          objName: node.obj.objName,
          treeKey: node.treeKey,
        };
        this.$emit('setSelectedNode', this.selectedObj);
      }
    },
    setSelectedObjToTable(row) {
      this.isFirstLoadTable = false;
      this.selectedObj = {
        objId: row.objId,
        objName: row.objName,
        ipaddress: row.ipaddress,
      };
      this.$emit('setSelectedNode', this.selectedObj);
    },
    onPhysicalObjFilterChange(params, columns) {
      this.objTypeFilterParams = {
        params,
        columns,
      };
    },
    onClickInterfaceButton(row) {
      this.selectedDeviceData = row;
      this.showInterfaceList = !this.showInterfaceList;
    },
  },
};
</script>

<style module>
.pointer i:hover{
  font-weight: bold;
  color: #4092ff;
}

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/SettingTargetObjTree.vue